import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NewsService } from '../news/news.service';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { timeout } from 'rxjs';
import { FooterComponent } from '../../shared/footer/footer.component';

@Component({
  selector: 'app-news-details',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, FooterComponent],
  templateUrl: './news-details.component.html',
  styleUrl: './news-details.component.scss',
})
export class NewsDetailsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private newsService = inject(NewsService);
  public translate = inject(TranslateService);
  private sanitizer = inject(DomSanitizer);

  newsItem: any = null;
  loading = true;

  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id && !isNaN(+id)) {
      this.newsService.getNewsById(+id)
        .pipe(timeout(5000))
        .subscribe({
          next: (news) => {
            this.newsItem = news;
            this.loading = false;
            this.cdr.detectChanges();
          },
          error: (err) => {
            console.error('Error fetching news details:', err);
            this.loading = false;
            this.cdr.detectChanges();
          },
          complete: () => {
            this.loading = false;
            this.cdr.detectChanges();
          }
        });
    } else {
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  getFileUrl(filePath: string): string {
    if (!filePath) return '/media/images/custom/defualt-img.jpg';
    if (filePath.startsWith('http')) return filePath;
    return environment.baseUrl + '/Files/' + filePath;
  }

  sanitizeHtml(html: string) {
    if (!html) return '';
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
